var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{staticClass:"go-map w-100 rounded cursor-pointer",staticStyle:{"text-align":"initial","line-height":"100%","width":"100%","height":"100%"},attrs:{"id":"map"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }